// Currency formatting
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};

// Loan purpose formatting
export const getLoanPurpose = (value: string): string => {
  const purposes = {
    'debt_consolidation': 'Debt Consolidation',
    'credit_card_refi': 'Credit Card Refinancing',
    'emergency': 'Emergency Expenses',
    'home_improvement': 'Home Improvement',
    'large_purchases': 'Large Purchases',
    'other': 'Other'
  } as const;
  return purposes[value as keyof typeof purposes] || 'Not specified';
};

// Employment status formatting
export const getEmploymentStatus = (value: string): string => {
  const statuses = {
    'employed': 'Employed',
    'employed_full_time': 'Full-Time Employed',
    'employed_part_time': 'Part-Time Employed',
    'military': 'Military',
    'not_employed': 'Not Employed',
    'self_employed': 'Self-Employed',
    'retired': 'Retired',
    'other': 'Other'
  } as const;
  return statuses[value as keyof typeof statuses] || 'Not specified';
};

// Property status formatting
export const getPropertyStatus = (value: string): string => {
  const statuses = {
    'own_outright': 'Own Outright',
    'own_with_mortgage': 'Own with Mortgage',
    'rent': 'Rent'
  } as const;
  return statuses[value as keyof typeof statuses] || 'Not specified';
};

// Education level formatting
export const getEducationLevel = (value: string): string => {
  const levels = {
    'high_school': 'High School or GED',
    'associate': "Associate's Degree",
    'bachelors': "Bachelor's Degree",
    'masters': "Master's Degree",
    'doctorate': 'Doctorate',
    'other_grad_degree': 'Other Graduate Degree',
    'certificate': 'Certificate/Certification',
    'did_not_graduate': 'Did Not Graduate',
    'still_enrolled': 'Currently Enrolled',
    'other': 'Other'
  } as const;
  return levels[value as keyof typeof levels] || 'Not specified';
};